<template>
  <header class="topbar">
    <div class="topbar-brand">
      <a :href="site_url" class="topbar-logo" aria-label="Linktone"></a>
    </div>
    <nav class="topbar-nav">
      <span class="topbar-link">כבר רשומים? <a href="#" @click.prevent="$emit('go-login')">התחברו</a></span>
      <button class="topbar-theme" @click="$emit('toggle-theme')" aria-label="החלף ערכת נושא">
        <span class="topbar-theme-knob" :class="theme === 'dark' ? 'right' : 'left'"></span>
        <span class="topbar-theme-lbl light">בהיר</span>
        <span class="topbar-theme-lbl dark">כהה</span>
      </button>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'TopBar',
  props: { theme: { type: String, default: 'light' } },
  emits: ['toggle-theme', 'go-login'],
}
</script>
